/// <reference types="./typings" />

/**
 * @license
 * Copyright (c) 2022 Tyler Technologies, Inc.
 * License: Apache-2.0 
 */

import { defineCustomElements } from '@tylertech/forge-core';
import { FooterComponent } from './footer';
import { FooterItemComponent } from './footer/footer-item';
import { AppLauncherComponent } from './app-launcher';
import { AppLauncherButtonComponent } from './app-launcher/app-launcher-button';

export * from './constants';
export * from './footer';
export * from './app-launcher';
export * from './landing-page-layout';

const CUSTOM_ELEMENTS = [
  FooterComponent,
  FooterItemComponent,
  AppLauncherComponent,
  AppLauncherButtonComponent
];

/** Registers all components in the library, or the provided array of components with the browser. */
export function defineComponents(components?: Array<typeof HTMLElement>): void {
  defineCustomElements(components ?? CUSTOM_ELEMENTS);
}
